const isRelationshipTypeValue = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return true;
  }

  if (!value || typeof value !== "object") {
    return false;
  }

  const record = value as Record<string, unknown>;
  return (
    (record.versions !== undefined &&
      record.versions !== null &&
      typeof record.versions === "object") ||
    typeof record.href === "string"
  );
};

/**
 * Normalizes record-service relationship payloads into a flat map of
 * relationship type → value.
 *
 * The record API models relationships as `{ data: Record<string, Item[]> }`.
 * After `customFetch` unwraps the outer HTTP envelope, callers may still receive
 * that nested `data` object — which breaks gallery/cover resolution that looks
 * up keys like `Document` or `documents`.
 */
export const normalizeRecordRelationships = (payload: unknown): Record<string, unknown> => {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return {};
  }

  const root = payload as Record<string, unknown>;
  const topLevelHasRelationshipEntries = Object.entries(root).some(
    ([key, value]) => key !== "data" && isRelationshipTypeValue(value),
  );

  if (
    !topLevelHasRelationshipEntries &&
    root.data &&
    typeof root.data === "object" &&
    !Array.isArray(root.data)
  ) {
    return root.data as Record<string, unknown>;
  }

  return root;
};
